// 日別タイムラインで Visit をどの位置に並べるか
import { startOfDay } from 'date-fns'

import type { OverlandVisit } from '@/api/types/overland'
import { isSameDate } from '@/lib/date-utils'

/**
 * 指定日のタイムラインに Visit を並べるときの時刻を返す。表示しない場合は null。
 *
 * - 指定日に到着した Visit は到着時刻
 * - 前日以前に到着して指定日まで続いている Visit は、指定日の 0:00（タイムラインの先頭）
 *
 * 出発時刻が無い（滞在中）Visit は現在まで続いているとみなす。
 */
export const getVisitTimelineTimestamp = (visit: OverlandVisit, date: Date, now: Date = new Date()): Date | null => {
  const arrival = new Date(visit.arrival_date ?? visit.timestamp)
  if (Number.isNaN(arrival.getTime())) return null
  if (isSameDate(arrival, date)) return arrival

  const dayStart = startOfDay(date)
  if (arrival >= dayStart) return null

  const departure = visit.departure_date ? new Date(visit.departure_date) : now
  if (Number.isNaN(departure.getTime()) || departure < dayStart) return null
  return dayStart
}
